// extracted by mini-css-extract-plugin
module.exports = {"modal":"Modal_modal__19qg6","bg":"Modal_bg__2_bXK","content":"Modal_content__2hGMo","successModalClose":"Modal_successModalClose__3KlrM"};